// react
import React from 'react';

// mui
import { Avatar, ButtonBase } from '@mui/material';

// hooks
import { useCachedSvg } from '@/pwa/hooks/useCachedSvg';

export interface AvatarOptionThumbnailProps {
  src: string;
  isSelected: boolean;
  onClick: () => void;
  alt?: string;
}

/**
 * AvatarOptionThumbnail displays a small avatar thumbnail for component option selection.
 * Uses SVG caching to avoid re-fetching avatar images.
 */
export const AvatarOptionThumbnail = ({
  src,
  isSelected,
  onClick,
  alt,
}: AvatarOptionThumbnailProps) => {
  const cachedSrc = useCachedSvg(src);

  return (
    <ButtonBase
      onClick={onClick}
      sx={{ borderRadius: 1, p: 0.5 }}
      aria-label={alt}
    >
      <Avatar
        variant='square'
        src={cachedSrc ?? src}
        alt={alt}
        sx={{
          width: 128,
          height: 128,
          bgcolor: 'grey.100',
          borderRadius: 1,
          outline: isSelected ? '3px solid' : 'none',
          outlineColor: 'primary.main',
          outlineOffset: 2,
          transition: 'outline 0.15s',
        }}
      />
    </ButtonBase>
  );
};

AvatarOptionThumbnail.displayName = 'AvatarOptionThumbnail';
export default AvatarOptionThumbnail;
